import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * Standards band — short trust callouts. Static content; the copy
 * deck drives the text so the marketing deck can swap wording.
 */
import { mono, sans, serif } from '../fonts.js';
export function StandardsBand({ theme, copy }) {
    const s = copy.standards;
    return (_jsxs("section", { style: { display: 'grid', gap: 18 }, children: [_jsx("span", { style: {
                    ...mono,
                    fontSize: 11,
                    letterSpacing: 2,
                    textTransform: 'uppercase',
                    color: theme.muted,
                }, children: s.kicker }), _jsx("h2", { style: {
                    ...serif,
                    fontWeight: 400,
                    fontSize: 30,
                    lineHeight: 1.1,
                    margin: 0,
                    color: theme.text,
                    textWrap: 'balance',
                }, children: s.heading }), _jsx("div", { className: "pr-std-grid", style: {
                    display: 'grid',
                    gridTemplateColumns: 'repeat(3, minmax(0, 1fr))',
                    gap: 16,
                }, children: s.items.map((item) => (_jsxs("div", { style: {
                        borderTop: `1px solid ${theme.text}`,
                        paddingTop: 14,
                        display: 'grid',
                        gap: 8,
                        alignContent: 'start',
                    }, children: [_jsx("b", { style: { ...sans, color: theme.text, fontWeight: 500 }, children: item.title }), _jsx("p", { style: { ...sans, fontSize: 14, color: theme.body, margin: 0, lineHeight: 1.5 }, children: item.body }), item.tags !== undefined ? (_jsx("div", { style: { display: 'flex', flexWrap: 'wrap', gap: 6, marginTop: 4 }, "aria-label": "Standards", children: item.tags.map((t) => (_jsx("span", { style: {
                                    ...mono,
                                    fontSize: 11,
                                    border: `1px solid ${theme.border}`,
                                    borderRadius: 2,
                                    padding: '2px 6px',
                                    color: theme.text,
                                    background: theme.surface,
                                }, children: t }, t))) })) : null] }, item.title))) })] }));
}
//# sourceMappingURL=StandardsBand.js.map